<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Citas y Admisión</h4>
        </div>
        <div class="col-1">
          <button class="btn-help" type="button" title="Abrir ayuda"
                  @click="showModalHelp = true" aria-label="Abrir ayuda de citas">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Citas">
      <AyudaCita />
    </Modal>
    <hr>

    <!-- DataTable -->
<DataTable
  :data="citas"
  :columns="columnas"
  idField="idCita"
  :mostrarBotonTodos="false"
  :mostrarBotonNuevo="true"
  :mostrarBotonExcel="true"
  :mostrarEditar="false"
  :mostrarVer="false"
  :mostrarEliminar="false"
  :mostrarInfo="true"
  mensajeVacio="No hay citas disponibles."
  @refresh="fetchCitas()"
  @create="abrirAsistente"  
  @info="row => abrirModalEditar(row.idCita)"
>
  <template #acciones-extra>
<!--  
    <div class="col-auto">
      <img src="@/assets/images/atenciones/asistente_citas_09.png"
           alt="Asistente" title="Asistente para la creación de citas"
           @click="abrirAsistente"
           @mouseover="hoverEffect(true)"
           @mouseleave="hoverEffect(false)"
           :style="imgStyle"
           role="button" tabindex="0"
           @keydown.enter="abrirAsistente">
    </div>
-->
    <div class="col-auto">
      <button type="button"
              class="btn btn-info btn-sm d-flex align-items-center gap-1"
              @click.prevent="getCitasPorMedico()"
              title="Citas de hoy">
        <span class="material-symbols-outlined" style="font-size:16px">pending_actions</span>
        Hoy
      </button>
    </div>
  </template>

  <template #cell-fechaCita="{ row }">
    {{ getFormattedDate(row.fechaCita) }}
  </template>

  <template #cell-estadoCita="{ row }">
    <span class="badge-estado" :class="getClassForCitaEstado(row.estadoCita)">
      {{ row.estadoCita }}
    </span>
  </template>

  <template #acciones-fila="{ row }">
    <select
      v-if="['PROGRAMADA', 'CONFIRMADA'].includes(row.estadoCita)"
      class="form-select form-select-sm"
      style="min-width:160px"
      @change="actualizarEstadoCita(row.idCita, $event.target.value)"
      @click.stop
    >
      <option disabled selected>Seleccione...</option>
      <option value="CONFIRMADA"   v-if="row.estadoCita === 'PROGRAMADA'">Confirmar cita</option>
      <option value="EN PROCESO"   v-if="['PROGRAMADA','CONFIRMADA'].includes(row.estadoCita)">Iniciar cita</option>
      <option value="REPROGRAMADA" v-if="['PROGRAMADA','CONFIRMADA'].includes(row.estadoCita)">Reprogramar cita</option>
      <option value="CANCELADA"    v-if="['PROGRAMADA','CONFIRMADA'].includes(row.estadoCita)">Cancelar cita</option>
      <option value="AUSENCIA"     v-if="['PROGRAMADA','CONFIRMADA'].includes(row.estadoCita)">No asiste a la cita</option>
    </select>
  </template>
</DataTable>

    <!-- Modal detalle cita -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalCitaLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalCitaLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row mb-2" v-for="campo in camposModal" :key="campo.label">
              <div class="col-3"><label class="fw-bold">{{ campo.label }}</label></div>
              <div class="col-9">
                <span class="form-control-plaintext" style="text-transform:uppercase">
                  {{ campo.valor }}
                </span>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-3"><label class="fw-bold">Fecha Cita</label></div>
              <div class="col-3">
                <span class="form-control-plaintext">{{ getFormattedDate(datoCita.fechaCita) }}</span>
              </div>
              <div class="col-3"><label class="fw-bold">Estado Cita</label></div>
              <div class="col-3">
                <span class="form-control-plaintext" style="text-transform:uppercase">
                  {{ datoCita.estadoCita }}
                </span>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-3"><label class="fw-bold">Hora Desde</label></div>
              <div class="col-3">
                <span class="form-control-plaintext">{{ datoCita.horaDesde }}</span>
              </div>
              <div class="col-3"><label class="fw-bold">Hora Hasta</label></div>
              <div class="col-3">
                <span class="form-control-plaintext">{{ datoCita.horaHasta }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout    from '@/components/Layout.vue'
import Footer    from '@/components/Footer.vue'
import AyudaCita from '@/views/ayuda/AyudaCita.vue'
import DataTable from '@/components/DataTable.vue'
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'
import { openModal } from '@/modules/modalHelper.js'
import swal2      from 'sweetalert2'

export default {
  name: 'Citas',
  components: { Layout, Footer, AyudaCita, DataTable },

  data() {
    return {
      citas:           [],
      datoCita:        {},
      estadoBusqueda:  '',
      numeroBusqueda:  '',
      cedulaBusqueda:  '',
      nombreBusqueda:  '',
      titulo:          '',
      modalWindow:     true,
      showModalHelp:   false,
      p_idEmpresa:     0,
      p_idPerfil:      0,
      p_idMedico:      0,
      imgStyle: {
        width: '64px', height: '64px', cursor: 'pointer',
        border: '2px solid blue', borderRadius: '8px',
        display: 'block', transition: 'all 0.3s ease-in-out',
      },

      columnas: [
        { field: 'numero',            label: 'Núm.' },
        { field: 'fechaCita',         label: 'Fecha' },
        { field: 'horaDesde',         label: 'Hora' },
        {
          field: 'estadoCita',
          label: 'Estado',
          filterType: 'select',
          filterOptions: [
            'PROGRAMADA',
            'CONFIRMADA',
            'EN PROCESO',
            'PROCESADA',
            'REPROGRAMADA',
            'CANCELADA',
            'AUSENCIA',
          ],
        },
        { field: 'documentoPaciente', label: 'Cédula' },
        { field: 'nombrePaciente',    label: 'Paciente' },
        {
          field: 'nombreEspecialidad',
          label: 'Especialidad',
          filterType: 'select',
          filterOptions: [],
        },
      ],
    }
  },

  computed: {
    camposModal() {
      return [
        { label: 'Número',      valor: this.datoCita.numero },
        { label: 'Persona',     valor: this.datoCita.nombrePaciente },
        { label: 'Médico',      valor: this.datoCita.nombreMedico },
        { label: 'Especialidad',valor: this.datoCita.nombreEspecialidad },
        { label: 'Motivo',      valor: this.datoCita.nombreMotivoCita },
        { label: 'Descripción', valor: this.datoCita.descripcion },
        { label: 'Observación', valor: this.datoCita.observacion },
      ]
    },
    opcionesEspecialidad() {
      const set = new Set(this.citas.map(c => c.nombreEspecialidad).filter(Boolean))
      return [...set].sort()
    },
  },

  watch: {
    opcionesEspecialidad(vals) {
      const col = this.columnas.find(c => c.field === 'nombreEspecialidad')
      if (col) col.filterOptions = vals
    },
  },

  mounted() {
    this.p_idEmpresa = window.sessionStorage.getItem('idEmpresa')
    this.p_idPerfil  = window.sessionStorage.getItem('idPerfil')
    this.p_idMedico  = window.sessionStorage.getItem('idMedico')
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchCitas()
  },

  methods: {
    getFormattedDate(date) { return dateFormat.getFormattedDate(date) },

    clearFields(activeField) {
      if (activeField !== 'estado') this.estadoBusqueda = ''
      if (activeField !== 'numero') this.numeroBusqueda = ''
      if (activeField !== 'cedula') this.cedulaBusqueda = ''
      if (activeField !== 'nombre') this.nombreBusqueda = ''
    },

    getCitasPorMedico() {
      const hoy   = new Date()
      const fecha = hoy.toISOString().slice(0, 10)
      api.get('/vwcitas/por-fecha-medico', {
        params: {
          idMedico:   this.p_idMedico,
          fechaDesde: `${fecha}T00:00:00`,
          fechaHasta: `${fecha}T23:59:59`,
        },
      })
      .then(response => { this.citas = response.data.reverse() })
      .catch(error   => {
        console.error('Error al obtener citas:', error)
        swal2.fire('Error', 'No se encontraron datos con los criterios proporcionados.', 'error')
      })
    },

    fetchCitas() {
      api.get(`/vwcitas/idempresa/${this.p_idEmpresa}`)
        .then(response => { this.citas = response.data.reverse() })
        .catch(error   => {
          console.error('Error al obtener citas:', error)
          swal2.fire('Error', 'No se encontraron datos con los criterios proporcionados.', 'error')
        })
    },

    abrirModalEditar(idCita) {
      this.modalWindow = true
      if (idCita) {
        api.get(`/vwcitas/${idCita}`).then(resp => { this.datoCita = resp.data })
      }
      openModal('ventanaModal')
      this.titulo = 'Resumen de la Cita'
    },

    async abrirAsistente() {
      window.sessionStorage.setItem('idAtencion', 0)
      const { data: contador } = await api.get(`/vwmedicos/countByEmpresa/${this.p_idEmpresa}`)
      if (contador === 0) {
        if (window.sessionStorage.getItem('suscriptor') == 1) {
          const result = await swal2.fire({
            title: 'Registro de Médicos Necesario',
            text: '¿Deseas registrarte como médico ahora para poder crear citas?',
            icon: 'warning',
            confirmButtonText: 'Registrar Médico',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor:  '#d33',
          })
          if (result.isConfirmed) {
            this.$router.push('/personaform/' + window.sessionStorage.getItem('idPersona'))
          } else {
            swal2.fire('Registro Pendiente', 'Para crear citas, primero necesitas tener al menos un médico registrado.', 'info')
          }
        } else {
          swal2.fire('Registro Necesario', 'Registra un médico para continuar.', 'info')
        }
        return
      }
      this.$router.push('/pacientecita01/0')
    },

async actualizarEstadoCita(idCita, nuevoEstado) {
  // Mensajes de confirmación por estado
  const confirmaciones = {
    CONFIRMADA: {
      title:             '¿Confirmar cita?',
      text:              'Se notificará al paciente que su cita ha sido confirmada.',
      icon:              'question',
      confirmButtonText: 'Sí, confirmar',
      confirmButtonColor:'#3085d6',
    },
    'EN PROCESO': {
      title:             '¿Iniciar la cita?',
      text:              'Se creará automáticamente un registro de atención.',
      icon:              'question',
      confirmButtonText: 'Sí, iniciar',
      confirmButtonColor:'#6eaff2',
    },
    REPROGRAMADA: {
      title:             '¿Reprogramar la cita?',
      text:              'Serás redirigido para seleccionar una nueva fecha y hora.',
      icon:              'question',
      confirmButtonText: 'Sí, reprogramar',
      confirmButtonColor:'#f7d08a',
    },
    CANCELADA: {
      title:             '¿Cancelar la cita?',
      text:              'Esta acción no se puede deshacer.',
      icon:              'warning',
      confirmButtonText: 'Sí, cancelar',
      confirmButtonColor:'#f76c6c',
    },
    AUSENCIA: {
      title:             '¿Marcar como ausente?',
      text:              'Se registrará que el paciente no asistió a la cita.',
      icon:              'warning',
      confirmButtonText: 'Sí, marcar ausencia',
      confirmButtonColor:'#aaa',
    },
  }

  // Confirmación previa
  const confirm = confirmaciones[nuevoEstado]
  if (confirm) {
    const { isConfirmed } = await swal2.fire({
      ...confirm,
      showCancelButton:  true,
      cancelButtonText:  'Cancelar',
      cancelButtonColor: '#6c757d',
    })
    if (!isConfirmed) return
  }

  // Loading solo para EN PROCESO
  if (nuevoEstado === 'EN PROCESO') {
    swal2.fire({
      title:             'Iniciando cita...',
      text:              'Por favor espera mientras se crea el registro de atención.',
      allowOutsideClick: false,
      showConfirmButton: false,
      willOpen:          () => swal2.showLoading(),
    })
  }

  try {
    const { data: cita } = await api.get(`/citas/${idCita}`)

    const { data: atencionDto } = await api.post(
      `/citas/actestadocita?estadoCita=${nuevoEstado}&idUsuario=${window.sessionStorage.getItem('idUsuario')}`,
      cita
    )

    // Mensajes de éxito por estado
    const mensajesExito = {
      CONFIRMADA: () => swal2.fire({
        title:             '¡Cita confirmada!',
        text:              `La cita N° ${cita.numero} fue confirmada exitosamente.`,
        icon:              'success',
        confirmButtonText: 'Aceptar',
        confirmButtonColor:'#3085d6',
      }),

      'EN PROCESO': async () => {
        const result = await swal2.fire({
          title:             '¡Cita iniciada!',
          html:              `La cita N° <b>${cita.numero}</b> fue iniciada.<br>
                              Se creó el registro de atención N° <b>${atencionDto.numero}</b>.`,
          icon:              'success',
          confirmButtonText: `Abrir atención ${atencionDto.numero}`,
          showCancelButton:  true,
          showDenyButton:    true,
          denyButtonText:    'Nueva cita',
          cancelButtonText:  'Cerrar',
          confirmButtonColor:'#3085d6',
          denyButtonColor:   '#78c2ad',
          cancelButtonColor: '#6c757d',
        })
        if (result.isConfirmed)   this.$router.push(`/atencionform/${atencionDto.idAtencion}`)
        else if (result.isDenied) this.$router.push('/pacientecita01/0')
      },

      REPROGRAMADA: () => {
        swal2.fire({
          title:             'Cita marcada para reprogramar',
          text:              `La cita N° ${cita.numero} será reprogramada.`,
          icon:              'info',
          timer:             1500,
          showConfirmButton: false,
        }).then(() => {
          this.$router.push(`/pacientecita02/${cita.idPersona}/${cita.idEspecialidad}/${cita.idMedico}`)
        })
      },

      CANCELADA: () => swal2.fire({
        title:             'Cita cancelada',
        text:              `La cita N° ${cita.numero} fue cancelada.`,
        icon:              'info',
        confirmButtonText: 'Aceptar',
        confirmButtonColor:'#3085d6',
      }),

      AUSENCIA: () => swal2.fire({
        title:             'Ausencia registrada',
        text:              `Se registró la ausencia del paciente en la cita N° ${cita.numero}.`,
        icon:              'info',
        confirmButtonText: 'Aceptar',
        confirmButtonColor:'#3085d6',
      }),
    }

    await mensajesExito[nuevoEstado]?.()

  } catch (error) {
    const mensajesError = {
      CONFIRMADA:   'No se pudo confirmar la cita.',
      'EN PROCESO': 'No se pudo iniciar la cita.',
      REPROGRAMADA: 'No se pudo reprogramar la cita.',
      CANCELADA:    'No se pudo cancelar la cita.',
      AUSENCIA:     'No se pudo registrar la ausencia.',
    }
    swal2.fire({
      title: 'Error',
      text:  mensajesError[nuevoEstado] || 'No se pudo actualizar el estado de la cita.',
      icon:  'error',
    })
    console.error(`Error al cambiar estado a ${nuevoEstado}:`, error)
  }
},

    getClassForCitaEstado(estado) {
      return {
        'PROGRAMADA':   'programada',
        'REPROGRAMADA': 'reprogramada',
        'CONFIRMADA':   'confirmada',
        'EN PROCESO':   'en-proceso',
        'CANCELADA':    'cancelada',
        'AUSENCIA':     'ausencia',
      }[estado] || ''
    },

    hoverEffect(isHovering) {
      this.imgStyle.filter    = isHovering ? 'brightness(1.2)' : ''
      this.imgStyle.transform = isHovering ? 'scale(1.1)'      : ''
    },
  },
}
</script>

<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.badge-estado {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}
.programada   { background-color: #a2cf6e; }
.reprogramada { background-color: #f7d08a; }
.confirmada   { background-color: #68b3c8; }
.en-proceso   { background-color: #6eaff2; }
.cancelada    { background-color: #f76c6c; }
.ausencia     { background-color: #e2e2e2; }
.modal-body label { font-weight: bold; }
img:hover {
  border-color: rgb(253, 209, 13);
  box-shadow: 0 0 10px 2px rgb(253, 209, 13);
  transform: translateY(-5px);
}
</style>
<style>
.busqueda-bar {
  display: flex; flex-wrap: wrap; align-items: flex-end; gap: 10px;
}
.busqueda-asistente { display: flex; align-items: flex-end; flex-shrink: 0; }
.busqueda-campo { display: flex; flex-direction: column; min-width: 130px; flex: 1; }
.busqueda-campo--sm { flex: 0 1 130px; }
.busqueda-campo--lg { flex: 2 1 200px; }
.busqueda-bar .form-label { font-size:12px; font-weight:500; margin-bottom:3px; color:#6c757d; }
.btn-icono { display:inline-flex; align-items:center; justify-content:center; padding:6px 10px; flex-shrink:0; }
@media (max-width: 576px) {
  .busqueda-campo, .busqueda-campo--sm, .busqueda-campo--lg { flex: 1 1 100%; }
  .btn-icono { width: 100%; }
  .busqueda-asistente { width: 100%; justify-content: center; }
}
</style>